// WMS Paneli (akıllı depo gösterge paneli) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.dashboard';

export const wmsDashboardGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'WMS Paneli nasıl okunur?'),
  intro: t(`${G}.intro`, 'Akıllı deponun o anki durumunu tek ekranda gösterir: bekleyen ve işlemdeki siparişler, toplama / paketleme hızı, aktif iş emirleri ve son işlemler. Panel yalnız gösterir, hiçbir kaydı değiştirmez. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Depo, dönem, Widget Ayarları'),
    stats: t(`${G}.regions.stats`, 'Özet kartlar'),
    table: t(`${G}.regions.table`, 'Grafikler, iş emirleri, son işlemler'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Depoyu ve dönemi seçin'),
      text: t(`${G}.s1.text`, '"Depo" listesinden akıllı depoyu seçin. "Bugün", "Bu Hafta", "Bu Ay" düğmeleri grafiklerin dönemini değiştirir. "Tarih Aralığı" düğmesi henüz kullanılamaz.'),
    },
    {
      region: 'stats',
      title: t(`${G}.s2.title`, '2. Özet kartları okuyun'),
      text: t(`${G}.s2.text`, 'Kartlar dönemden bağımsız, anlık durumu gösterir: Bekleyen Sipariş, Toplamada, Paketlemede, Kargoya Verildi, Aktif İş Emirleri, Toplam Toplayıcı (devam eden iş emri olan toplayıcı sayısı), Ort. Toplama (bugün tamamlanan iş emirlerinin ortalama süresi), Stok Doğruluk, Depo Doluluk Oranı ve Kargo Bekleyen.'),
      tips: [
        t(`${G}.s2.tip1`, 'Stok Doğruluk: son 10 tamamlanan / onaylanan sayım görevinde (lokasyon − fark) ÷ lokasyon oranı.'),
        t(`${G}.s2.tip2`, 'Depo Doluluk Oranı: aktif ve toplanabilir lokasyonlardan stok bulunanların oranı (dolu / toplam).'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Grafikler ve sipariş hattı'),
      text: t(`${G}.s3.text`, 'Saatlik (haftalık / aylık dönemde günlük) sipariş grafiği gelen, toplanan ve paketlenen sayıları gösterir. "Toplama vs Paketleme" toplanan, paketlenen ve kargolanan miktarları karşılaştırır. "SİPARİŞ HATTI" siparişlerin hangi aşamada beklediğini (Bekleyen, Stok bekleyen, Toplamada, Paketlemede, Paketlendi, Bugün kargolanan), kargo bekleyen ve bugün iptal sayısını ve açık sipariş kanallarını gösterir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Aktif iş emirleri ve son işlemler'),
      text: t(`${G}.s4.text`, '"AKTİF İŞ EMİRLERİ" devam eden iş emirlerini toplayıcı, ürün ve ilerleme ile listeler. "SON İŞLEMLER" bugünkü toplama, paketleme, mal kabul ve sayım hareketlerini gösterir. Bu iki bölüm her 10 saniyede kendiliğinden yenilenir.'),
    },
    {
      region: 'header',
      title: t(`${G}.s5.title`, '5. Widget ayarları'),
      text: t(`${G}.s5.text`, '"Widget Ayarları" ile panelde görmek istediğiniz bölümleri (Özet kartlar, sipariş grafiği, Toplama vs paketleme, Sipariş hattı ve kanallar, Aktif iş emirleri, Son işlemler) açıp kapatın; "Varsayılana dön" hepsini geri getirir. Tercih bu tarayıcıda saklanır.'),
    },
  ],
});
